import { POST } from "./index";

export function translate(options) {
  return POST("/translate", { options });
}
